// extracted by mini-css-extract-plugin
module.exports = {"scrollbar":"filters_scrollbar__3dbSn"};